import { cn } from "@/lib/utils";

function Bar({ className }: { className?: string }) {
  return <div className={cn("animate-pulse rounded-md bg-biz-muted", className)} />;
}

export interface DashboardSkeletonProps {
  className?: string;
  loadingLabel?: string;
}

export function DashboardSkeleton({ className, loadingLabel }: DashboardSkeletonProps) {
  return (
    <div
      className={cn("flex flex-col gap-4 p-4 sm:p-6", className)}
      role="status"
      aria-busy="true"
      aria-live="polite"
    >
      {loadingLabel && <span className="sr-only">{loadingLabel}</span>}
      {/* Hero */}
      <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
        <div className="flex flex-col gap-2">
          <Bar className="h-3 w-40" />
          <Bar className="h-7 w-56" />
          <Bar className="h-3 w-72" />
        </div>
        <Bar className="h-9 w-44 rounded-full" />
      </div>
      {/* KPI grid */}
      <div className="grid grid-cols-2 gap-3 md:grid-cols-3 xl:grid-cols-6">
        {Array.from({ length: 6 }).map((_, i) => (
          <div
            key={i}
            className="rounded-biz-card border border-biz-border bg-biz-surface-elevated p-4 biz-shadow-sm"
          >
            <Bar className="h-9 w-9 rounded-biz-btn" />
            <Bar className="mt-3 h-3 w-20" />
            <Bar className="mt-2 h-7 w-24" />
            <Bar className="mt-2 h-3 w-28" />
          </div>
        ))}
      </div>
      {/* AI strip */}
      <div className="grid gap-3 md:grid-cols-2 xl:grid-cols-3">
        {Array.from({ length: 3 }).map((_, i) => (
          <div
            key={i}
            className="h-[140px] rounded-biz-card border border-biz-border bg-biz-surface-elevated p-4 biz-shadow-sm"
          >
            <Bar className="h-8 w-8 rounded-biz-btn" />
            <Bar className="mt-3 h-4 w-3/4" />
            <Bar className="mt-2 h-3 w-full" />
            <Bar className="mt-1 h-3 w-2/3" />
          </div>
        ))}
      </div>
      {/* Chart */}
      <div className="rounded-biz-card border border-biz-border bg-biz-surface-elevated p-4 biz-shadow-sm">
        <Bar className="h-4 w-32" />
        <Bar className="mt-2 h-3 w-56" />
        <Bar className="mt-3 h-[240px] w-full" />
      </div>
      {/* Two cols */}
      <div className="grid gap-3 lg:grid-cols-2">
        <Bar className="h-72 rounded-biz-card" />
        <Bar className="h-72 rounded-biz-card" />
      </div>
      <div className="grid gap-3 lg:grid-cols-2">
        <Bar className="h-64 rounded-biz-card" />
        <Bar className="h-64 rounded-biz-card" />
      </div>
      <Bar className="h-28 rounded-biz-card" />
    </div>
  );
}
